import { useState, useEffect } from "react";

function RenameBuildChapterModal({
  isOpen,
  currentName,
  onCancel,
  onSave
}) {
  const [newName, setNewName] = useState("");

  useEffect(() => {
    if (isOpen) {
      setNewName(currentName || "");
    }
  }, [isOpen, currentName]);

  if (!isOpen) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h2 style={{ marginTop: 0 }}>Rename Build Phase</h2>

        <label style={labelStyle}>New Build Phase Name</label>

        <input
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder="Example: Turbo Build"
          style={inputStyle}
        />

        <div style={buttonRowStyle}>
          <button onClick={onCancel} style={cancelButtonStyle}>
            Cancel
          </button>

          <button
            onClick={() => onSave(newName.trim())}
            disabled={!newName.trim()}
            style={{
              ...saveButtonStyle,
              opacity: newName.trim() ? 1 : 0.5,
              cursor: newName.trim() ? "pointer" : "not-allowed"
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.82)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 40000,
  padding: "20px"
};

const modalStyle = {
  backgroundColor: "#181818",
  border: "1px solid #333",
  borderRadius: "20px",
  padding: "22px",
  maxWidth: "420px",
  width: "100%",
  boxSizing: "border-box",
  color: "white"
};

const labelStyle = {
  display: "block",
  fontWeight: "bold",
  marginBottom: "8px"
};

const inputStyle = {
  width: "100%",
  padding: "14px",
  borderRadius: "12px",
  border: "1px solid #333",
  backgroundColor: "#1f1f1f",
  color: "white",
  boxSizing: "border-box"
};

const buttonRowStyle = {
  display: "flex",
  gap: "10px",
  marginTop: "22px"
};

const cancelButtonStyle = {
  flex: 1,
  backgroundColor: "#333",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer"
};

const saveButtonStyle = {
  flex: 1,
  backgroundColor: "#e10600",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold"
};

export default RenameBuildChapterModal;